// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"745":"f4a9bbd0","968":"619bc25b"}[chunkId] + ".chunk.css";
};